module.exports = __webpack_public_path__ + "static/people-d4b8dbe81c809304f42eee5679539d9d.png";